export default __webpack_public_path__ + "static/media/cv-najjar.212a5b61.pdf";